import { Button } from "common/components/ui/Button";
import {
  DialogBody,
  DialogFooter,
  DialogHeader,
} from "common/components/ui/Dialog";
import {
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
} from "common/components/ui/Drawer";
import ProfileImage from "common/components/ui/ProfileImage";
import { Tag } from "common/components/ui/Tag";
import useLicenseMutations from "common/datahooks/useLicenseMutations";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import type { WorkspaceAccount } from "common/types";

interface AssignSeatsProps {
  accounts: WorkspaceAccount[];
  onClose: () => void;
  onSuccess?: () => void;
}

export default function AssignSeats({
  accounts,
  onClose,
  onSuccess = undefined,
}: AssignSeatsProps) {
  const isDesktop = useTwBreakpoint("lg");

  const { assignLicenses, isAssigningLicenses } = useLicenseMutations();

  async function handleAssignLicenses() {
    await assignLicenses({ accountIds: accounts.map(({ id }) => id) });

    if (onSuccess) {
      onSuccess();
    }
  }
  const Footer = isDesktop ? DialogFooter : DrawerFooter;
  const Body = isDesktop ? DialogBody : DrawerBody;
  const Header = isDesktop ? DialogHeader : DrawerHeader;

  return (
    <>
      <Header
        title="Assign seats to campaign accounts?"
        subtitle="You need to assign seats in order to start this campaign"
      />

      <Body className="max-h-[min(378px,60dvh)] gap-y-3 overflow-y-auto scrollbar-thin">
        {accounts.map(({ id, picture_url, full_name, occupation }) => (
          <div
            key={id}
            className="flex items-center gap-x-2 rounded-3xl border border-black-200 p-3"
          >
            <ProfileImage src={picture_url} />

            <div className="flex flex-col gap-y-0.5">
              <div className="flex items-center gap-x-1">
                <h4 className="line-clamp-1 break-all text-sm-bold">
                  {full_name}
                </h4>

                <Tag variant="tertiary" size="sm">
                  No assigned seat
                </Tag>
              </div>

              <p className="line-clamp-1 break-all text-xs-medium text-black-500">
                {occupation}
              </p>
            </div>
          </div>
        ))}
      </Body>

      <Footer className="justify-end">
        <Button
          variant="secondary-black"
          disabled={isAssigningLicenses}
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          variant="gradient"
          onClick={handleAssignLicenses}
          isLoading={isAssigningLicenses}
        >
          Assign
        </Button>
      </Footer>
    </>
  );
}
